import { Table } from '@tanstack/react-table';
import { Button } from './button';

interface PaginationControlsProps<TData> {
  table: Table<TData>;
  className?: string;
  previousLabel?: string;
  nextLabel?: string;
  showPageInfo?: boolean;
  pageInfoTemplate?: (current: number, total: number) => string;
}

export function PaginationControls<TData>({
  table,
  className = '',
  previousLabel = 'zurück',
  nextLabel = 'nächste',
  showPageInfo = true,
  pageInfoTemplate
}: PaginationControlsProps<TData>) {
  const currentPage = table.getState().pagination.pageIndex + 1;
  const totalPages = table.getPageCount();

  const showMaxPages = totalPages === 0 ? 1 : totalPages;

  const defaultPageInfo = `Seite ${currentPage} von ${showMaxPages}`;
  const pageInfo = pageInfoTemplate ? pageInfoTemplate(currentPage, totalPages) : defaultPageInfo;

  return (
    <div className={`flex items-center justify-between py-4 my-2 ${className}`}>
      <Button
        className="text-[17px] text-[#12282A]"
        variant="outline"
        size="sm"
        onClick={() => table.previousPage()}
        disabled={!table.getCanPreviousPage()}>
        {previousLabel}
      </Button>
      {showPageInfo && <span className="text-sm text-[#D0D5DD]">{pageInfo}</span>}
      <Button className="text-[17px] text-[#12282A]" variant="outline" size="sm" onClick={() => table.nextPage()} disabled={!table.getCanNextPage()}>
        {nextLabel}
      </Button>
    </div>
  );
}
